import { MessageString, SpecialCharacterRegex } from './ResearchUIConstants';

export { descProhabitedWordsList, currencyList, mlDefaultHiddenValues, fieldRules, DefaultHiddenQuestionList };

const FieldRequiredRule = { required: true, message: MessageString.FIELD_REQUIRED };
const fieldRules = {
    appName: [
        FieldRequiredRule,
        {
            validator(_, value) {
                if (SpecialCharacterRegex.appName.test(value)) return Promise.reject(new Error(MessageString.SPEC_CHAR_NOT_ALLOWED));
                return Promise.resolve();
            },
        },
    ],
    url: [
        FieldRequiredRule,
        {
            validator(_, value) {
                if (!value.includes('http')) return Promise.reject(new Error(MessageString.URL_NOT_VALID));
                return Promise.resolve();
            },
        },
    ],
    category: [FieldRequiredRule],
};

const descriptionSpecialCharValidator = (value) => {
    if (SpecialCharacterRegex.description.test(value)) {
        return Promise.reject(new Error(MessageString.SPEC_CHAR_NOT_ALLOWED));
    }
    return Promise.resolve();
};

export const FormFieldRules = {
    BREACH: {
        default: [FieldRequiredRule],
        breachName: [FieldRequiredRule, { validator: async (_, value) => descriptionSpecialCharValidator(value) }],
        sourceField: [FieldRequiredRule, { validator: async (_, value) => descriptionSpecialCharValidator(value) }],
        source: [
            {
                validator: async (_, values) =>
                    values && values.length > 0 ? Promise.resolve() : Promise.reject(new Error(MessageString.SOURCE_FIELD_REQUIRED)),
            },
        ],
    },
    BASIC_INFO: {
        description: [
            {
                validator: async (_, value) => {
                    if (SpecialCharacterRegex.description.test(value)) {
                        return Promise.reject(new Error(MessageString.SPEC_CHAR_NOT_ALLOWED));
                    }
                    return Promise.resolve();
                },
            },
        ],
    },
};

const DefaultHiddenQuestionList = [
    'is_weak_cipher',
    'weak_cipher_suites',
    'weak_algorithm_keysize',
    'psm_securityheaders',
    'psm_spfrecord',
    'accounts',
    'contacts_calenderdata_messages_remainders',
    'system_operations',
    'apphosting',
    'entertime',
    'hosting_provider_locations',
    'select_priority',
    'hide_multistore_vendor',
    'sanctioned',
    'custom',
    'vulnerable',
];

const mlDefaultHiddenValues = {
    encryptionInTransit: 'Yes',
    cookies_3rd_party: 'Yes',
    disasterecovery: 'No',
    roleAuthBased: 'No',
    infrahealth: 'No',
    datapertenancy: 'No',
    dataOwnership: 'No',
    hostinggeo: 'No',
    hostinggeoback: 'No',
    adminauditlogs: 'No',
    userauditlogs: 'No',
    dataauditlogs: 'No',
    sharing_personal_info_3rd_party: 'Yes',
    granularpolicies: 'No',
    encryptionDataRest: 'NS',
    ipfilter: 'No',
    breachNotification: 'No',
    dataprocessor: 'No',
    dcexceptions: 'No',
    EnforcePassword: 'No',
    FS: 'No',
    EncryptTenantKey: 'No',
    dataClassification: 'No',
    classificationCapabilities: 'No',
    notificationLeadTime: 'No',
    anonymousFileSharing: 'No',
    multifactor: 'No',
    europedc: 'No',
    DataRetentionAtSaaSPostDereg: 'NS',
};

const descProhabitedWordsList = [
    'Most',
    'offer',
    'you',
    'leading',
    'global',
    'most',
    'innovation',
    'unique',
    'productive',
    'helps',
    'strategic',
    'special',
    'special characters',
    'offer',
    'we',
    'our',
    'highest level.',
    'reliable',
    'Awarded',
    'Awesome',
    'great',
    'super',
    'Fantastic',
    'most',
    'elegant',
    'efficient',
    'Powerful',
    'empower',
    'Unparalleled',
    'Best',
    'specializes',
    'specialized',
    'Top',
    'offers',
    'global ',
    'trustworthy',
    'Forbes',
    'secure',
    'secret',
    'good',
    'pioneer',
    'leading',
    'leader',
    'other.',
    'enterprise-grade',
    'next generation ',
    'best in class',
    'world class',
    'helps',
    'personalized',
    'personalization',
    'much more',
    'strong',
    'improves',
    'simplifies',
    'innovative',
    'easy',
    'boosting',
    'spirit',
    'happier',
    'healthier',
    'leads',
    'leading',
    'lead',
    'bad',
    'exceptional',
    'disruptor',
    'transforming',
    'save of cost',
    'promote',
    'comprehensive',
    'increase',
    'interesting',
    'etc',
    'productive',
    'state-of-the-art',
    'friendly',
    'well',
    'full range',
    'customized',
    'leverages',
    'scientifically',
    'commercially',
    'clean',
    'truth',
    'more',
    'proven',
    'emerging',
    'quickly',
    'efficiently',
    'advanced',
    'like',
    'among others',
    'asynchronous (edited) ',
    'your',
    'Growth',
    'Securely',
    'User Friendly',
    'worldwide',
    'better',
    'streamline',
].map((i) => i.toLowerCase());

const currencyList = [
    'AED',
    'AFN',
    'ALL',
    'AMD',
    'ANG',
    'AOA',
    'ARS',
    'AUD',
    'AWG',
    'AZN',
    'BAM',
    'BBD',
    'BDT',
    'BGN',
    'BHD',
    'BIF',
    'BMD',
    'BND',
    'BOB',
    'BRL',
    'BSD',
    'BTN',
    'BWP',
    'BYN',
    'BZD',
    'CAD',
    'CDF',
    'CHF',
    'CLP',
    'CNY',
    'COP',
    'CRC',
    'CUP',
    'CVE',
    'CZK',
    'DJF',
    'DKK',
    'DOP',
    'DZD',
    'EGP',
    'ERN',
    'ETB',
    'EUR',
    'FJD',
    'FKP',
    'GBP',
    'GEL',
    'GGP',
    'GHS',
    'GIP',
    'GMD',
    'GNF',
    'GTQ',
    'GYD',
    'HKD',
    'HNL',
    'HRK',
    'HTG',
    'HUF',
    'IDR',
    'ILS',
    'IMP',
    'INR',
    'IQD',
    'IRR',
    'ISK',
    'JEP',
    'JMD',
    'JOD',
    'JPY',
    'KES',
    'KGS',
    'KHR',
    'KMF',
    'KPW',
    'KRW',
    'KWD',
    'KYD',
    'KZT',
    'LAK',
    'LBP',
    'LKR',
    'LRD',
    'LSL',
    'LYD',
    'MAD',
    'MDL',
    'MGA',
    'MKD',
    'MMK',
    'MNT',
    'MOP',
    'MRU',
    'MUR',
    'MVR',
    'MWK',
    'MXN',
    'MYR',
    'MZN',
    'NAD',
    'NGN',
    'NIO',
    'NOK',
    'NPR',
    'NZD',
    'OMR',
    'PEN',
    'PGK',
    'PHP',
    'PKR',
    'PLN',
    'PYG',
    'QAR',
    'RON',
    'RSD',
    'RUB',
    'RWF',
    'SAR',
    'SBD',
    'SCR',
    'SDG',
    'SEK',
    'SGD',
    'SHP',
    'SLL',
    'SOS',
    'SRD',
    'SSP',
    'STN',
    'SYP',
    'SZL',
    'THB',
    'TJS',
    'TMT',
    'TND',
    'TOP',
    'TRY',
    'TTD',
    'TWD',
    'TZS',
    'UAH',
    'UGX',
    'USD',
    'UYU',
    'UZS',
    'VES',
    'VND',
    'VUV',
    'WST',
    'XAF',
    'XCD',
    'XDR',
    'XOF',
    'XPF',
    'YEN',
    'YER',
    'ZAR',
    'ZMW',
];
